export default "__VITE_ASSET__Cb3OkYN4__"